// src/components/RoleGuard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRoles } from '@/hooks/useRoles';
import { useAuth } from '@/contexts/AuthContext';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

interface RoleGuardProps {
  roles: string[];          // at least one required
  children: React.ReactNode;
  fallback?: string;        // redirect path, defaults to /dashboard
}

const RoleGuard: React.FC<RoleGuardProps> = ({ roles, children, fallback = '/dashboard' }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { hasAnyRole } = useRoles();

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center"><LoadingSpinner size="lg" /></div>;
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasAnyRole(...roles)) return <Navigate to={fallback} replace />;

  return <>{children}</>;
};

export default RoleGuard;
